import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';

const sheet = new CSSStyleSheet();
sheet.replaceSync(`
    :host {
        position: fixed;
        top: 1rem;
        right: 1rem;
        z-index: 9999;
        pointer-events: none;
    }
    .toast {
        pointer-events: auto;
        animation: slideIn 0.3s ease-out forwards;
    }
    @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
    }
`);

export default [tailwindSheet, baseStyles, sheet];
